<template>
  <div class="item" @click.capture="showModal" :style="getRolldProductStyles()">
    <div v-if="getProductImage(product)" class="item-img">
      <div
        v-lazy:background-image="getProductImage(product)"
        class="product-div-img"
        :style="imageRatioStyle"
      >
        <div class="triangle-container">
          <div v-if="status === undefined">
            <div
              class="triangle-topright-img"
              v-if="
                product.Status == 3 ||
                product.Status == 2 ||
                product.Status == 1
              "
              :class="{
                'triangle-topright-img-popular': product.Status == 2,
                'triangle-topright-img-sold': product.Status == 3,
                'triangle-topright-img-new': product.Status == 1,
              }"
            >
              <span>{{ product.Status | formatStatus(this) }}</span>
            </div>
          </div>
          <div v-else>
            <div
              class="triangle-topright-img"
              v-if="status == 3 || status == 2 || status == 1"
              :class="{
                'triangle-topright-img-popular': status == 2,
                'triangle-topright-img-sold': status == 3,
                'triangle-topright-img-new': status == 1,
              }"
            >
              <span>{{ status | formatStatus(this) }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="triangle-container">
        <div v-if="status === undefined">
          <div
            class="triangle-topright-noimg"
            v-if="
              product.Status == 3 || product.Status == 2 || product.Status == 1
            "
            :class="{
              'triangle-topright-img-popular': product.Status == 2,
              'triangle-topright-img-sold': product.Status == 3,
              'triangle-topright-img-new': product.Status == 1,
            }"
          >
            <span>{{ product.Status | formatStatus(this) }}</span>
          </div>
        </div>
        <div v-else>
          <div
            class="triangle-topright-noimg"
            v-if="status == 3 || status == 2 || status == 1"
            :class="{
              'triangle-topright-img-popular': status == 2,
              'triangle-topright-img-sold': status == 3,
              'triangle-topright-img-new': status == 1,
            }"
          >
            <span>{{ status | formatStatus(this) }} </span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-details">
      <h2 class="item-title">{{ getProductName() }}</h2>
      <p v-html="getProductDescription()" class="block-with-text-mobile"></p>
    </div>
    <div class="item-price d-flex">
      <h2>
        <template v-if="!priceOverride">
          {{ category.Price | formatMoney(currencySign) }}
        </template>
        <template v-else>
          <del>{{ category.Price | formatMoney(currencySign) }}</del>
          <span class="ml-2">{{ priceOverride | formatMoney(currencySign) }}</span>
        </template>
      </h2>
      <ul>
        <li
          v-for="(dietary, index) in dietaryList"
          :key="index"
          :style="getIconStyle(dietary)"
          :title="dietary.Name"
        ></li>
      </ul>
    </div>
    <div
      v-if="status"
      :class="productStatusClass(status)"
    >
    </div>
    <div
      v-if="status === undefined && product.Status"
      :class="productStatusClass(product.Status)"
    >
    </div>

    <Transition name="slide-fade">
      <AddToCart
        v-if="isModalVisible && showNewUi"
        :price="category.Price"
        :product-id="category.ProductID"
        :category="category"
        :parent-category="parentCategory"
        :product="product"
        :modifiers="modifiers"
        :image-styles="dialogImageRatioStyle"
      />
    </Transition>

    <AddToCart
      v-if="isModalVisible && !showNewUi"
      :price="category.Price"
      :product-id="category.ProductID"
      :category="category"
      :parent-category="parentCategory"
      :product="product"
      :modifiers="modifiers"
      :image-styles="dialogImageRatioStyle"
    />
  </div>
</template>

<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100vw);
  /*opacity: 0;*/
}
</style>
<script>
import AddToCart from "./AddToCartMobile";
import shared from "../../../sharedscripts/shop/products/Product.js";
import { mapGetters } from "vuex";
import { AppConfig } from "../../../../AppConfig";
import sharedTranslations from "@/sharedscripts/shop/products/Translations";
export default {
  name: "Product",
  components: { AddToCart },
  filters: {
    ...shared.filters,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
    parentCategory: {
      type: Object,
      default: () => {},
    },
    modifiers: {
      type: Object,
      default: () => {},
    },
    sectionId: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
    },
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0,
    };
  },
  computed: {
    ...mapGetters(["mobileStyles", "viewConfig"]),
    ...shared.computed,
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    ...sharedTranslations.methods,
    getRolldProductStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.mobileStyles.primaryBodyBackground);
      }
      return styles;
    },
    getProductImage(product) {
      if (!this.isRolldStore()) {
        if (product.PhotoUrl) return product.PhotoUrl;
        else return null;
      } else {
        return `https://firebasestorage.googleapis.com/v0/b/${AppConfig.firebaseProjectId}.appspot.com/o/Photos%2F${product.ProductCode}.jpg?alt=media&token=adc34ed7-644d-45b0-a617-1f88e8024243`;
      }
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
    productStatusClass(status) {
      let className = ""
      switch(status) {
        case 1:
          className = "new";
          break;
        case 2:
          className = "popular";
          break;
        case 3:
          className = "sold-out";
          break;
        default:
          className = "";
          break;
      }
      return className;
    }, 
  },
};
</script>
